/* KBW SEO Text — the read more / read less button.

   The clip itself is CSS. What the script adds is the decision: is this text
   actually taller than the clip? If it is not, the button never appears. The
   section this replaces showed the button either way, so on a short paragraph
   it offered to reveal nothing.

   Nothing here is required for the text to be readable. With scripting off a
   <noscript> block in the section lifts the clip and the whole thing shows —
   the button stays hidden, because there is nothing left for it to do.

   Markup contract:
     [data-kbw-seo]         the card, carries the state classes
     [data-kbw-seo-body]    the clipped text
     [data-kbw-seo-toggle]  the button, `hidden` until we know it is needed
     [data-kbw-seo-label]   the span whose text swaps
*/

(function () {
  'use strict';

  var reduced = window.matchMedia
    ? window.matchMedia('(prefers-reduced-motion: reduce)')
    : null;

  function setup(card) {
    if (card.dataset.kbwSeoReady === '1') return;

    var body = card.querySelector('[data-kbw-seo-body]');
    var btn = card.querySelector('[data-kbw-seo-toggle]');
    if (!body || !btn) return;

    card.dataset.kbwSeoReady = '1';

    var label = btn.querySelector('[data-kbw-seo-label]');
    var open = false;

    /* While the text is open its own height is the clip, so there is nothing
       to compare and nothing to decide. */
    function measure() {
      if (open) return;
      var truncatable = body.scrollHeight > body.clientHeight + 4;
      card.classList.toggle('is-truncatable', truncatable);
      btn.hidden = !truncatable;
    }

    btn.addEventListener('click', function () {
      open = !open;

      card.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (label) label.textContent = open ? btn.dataset.less : btn.dataset.more;

      /* max-height cannot animate to or from `none`, so both directions are
         given a pixel value to work with. */
      body.style.maxHeight = body.scrollHeight + 'px';

      if (open) {
        if (reduced && reduced.matches) body.style.maxHeight = 'none';
      } else {
        /* Reading offsetHeight lands the pixel value before the clip comes
           back, so the browser has two heights to move between. */
        void body.offsetHeight;
        body.style.maxHeight = '';
      }
    });

    /* Once it has finished opening the height is released, so the text can
       reflow freely when the window changes width. */
    body.addEventListener('transitionend', function (event) {
      if (event.propertyName === 'max-height' && open) {
        body.style.maxHeight = 'none';
      }
    });

    measure();

    /* A web font swapping in changes how many lines the text takes, which can
       turn a clipped paragraph into one that fits, or the other way round. */
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(measure);
    }

    var timer;
    window.addEventListener('resize', function () {
      window.clearTimeout(timer);
      timer = window.setTimeout(measure, 150);
    });
  }

  function setupAll() {
    var cards = document.querySelectorAll('[data-kbw-seo]');
    for (var i = 0; i < cards.length; i++) setup(cards[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupAll);
  } else {
    setupAll();
  }

  // The theme editor re-renders a section in place.
  document.addEventListener('shopify:section:load', setupAll);
})();
